"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _guessCountryFromDialCode = _interopRequireDefault(require("./guessCountryFromDialCode"));

var _default = function _default(value) {
  var numberFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  var numberText = value;
  var pattern = numberFormat;

  if (!pattern) {
    numberText = value.replace(/\D/g, '');
    var country = value[0] === '+' && (0, _guessCountryFromDialCode.default)(numberText);
    pattern = country && country.format;
  }

  if (!pattern) {
    return value;
  } // for all strings with length less than 3, just return it


  if (numberText && numberText.length < 2 || !pattern) {
    return "+" + numberText.replace(/\D/g, '');
  }

  var formattedObject = pattern.split('').reduce(function (acc, character) {
    if (acc.remainingText.length === 0) {
      return acc;
    }

    if (character !== '.') {
      return {
        formattedText: acc.formattedText + character,
        remainingText: acc.remainingText
      };
    }

    return {
      formattedText: acc.formattedText + acc.remainingText[0],
      remainingText: acc.remainingText.slice(1)
    };
  }, {
    formattedText: '',
    remainingText: numberText
  });
  return formattedObject.formattedText + formattedObject.remainingText;
};

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/I18n/static-7.547/js/utils/formatPhoneNumber.js
// module id = 403
// module chunks = 209 210 211 212